import { gql } from '@apollo/client';

export const QUERY = gql`
  mutation DowngradeSubscriptionByToken($token: String!, $payload: AutoFilledDowngradeSubscriptionPayload) {
    downgradeSubscriptionByToken(token: $token, payload: $payload) {
      downgradeToProduct
      downgradeToPrice
      startDate
      endDate
      cancelDate
      frequency
      status
      paymentRetryCount
      paymentReminderEndDate
      has3dsVerification
      reminder3dsEndDate
      billingCycleCount
      nextActionUrl
      amountDue
      lastPaymentDate
      nextPaymentAttemptDate
      terminateDate
      isCancelling
      cancelReason
      planRelationId
      _id
      createdAt
      updatedAt
      incompleteBillingDetails
      nextBillingDate
      renewalReminderDate
    }
  }
`;
